import {
  financialCalculationRoadmap,
  calculationFollowupText,
  type FinancialCalculationKey,
} from './financial-calculation-roadmap';
import { financialMoney } from './financial-money';

export function FinancialCalculationStatus({
  calculation,
  label = 'Non calculable',
  reason,
  hint,
}: {
  readonly calculation: FinancialCalculationKey;
  readonly label?: string;
  readonly reason?: string | undefined;
  readonly hint?: string | undefined;
}): React.JSX.Element {
  const task = financialCalculationRoadmap[calculation];
  return (
    <span
      className="finance-calculation-status"
      data-calculation-id={task.id}
      title={`${reason ?? task.reason} Suivi : ${task.id} (${task.lot}).`}
    >
      {label}{' '}
      <small>{hint ? `${hint} · S${task.sprint}` : calculationFollowupText(calculation)}</small>
    </span>
  );
}

export function FinancialAmount({
  cents,
  calculation = 'sources',
  reason,
  hint,
}: {
  readonly cents: string | null | undefined;
  readonly calculation?: FinancialCalculationKey;
  readonly reason?: string | undefined;
  readonly hint?: string | undefined;
}): React.JSX.Element {
  return cents == null ? (
    <FinancialCalculationStatus calculation={calculation} reason={reason} hint={hint} />
  ) : (
    <>{financialMoney(cents)}</>
  );
}
